import { Card, Checkbox, H4, Stack } from "@adfenix/alexandria";
import { ProgramService } from "@adfenix/types";
import { useFormContext } from "react-hook-form";
import { useDisabledFields } from "./useDisabledFields";
import { useTranslation } from "react-i18next";
import { ProgramNotificationsList } from "./ProgramNotificationsList";

export const ProgramNotifications = () => {
  const { t } = useTranslation();

  const { register } = useFormContext<ProgramService.ProgramModel>();
  const disabledFields = useDisabledFields();

  return (
    <Card>
      <Stack spacing={"m"}>
        <H4>
          {t("programBuilder.program.details.programNotification.header")}
        </H4>
        <Checkbox
          {...register("disableAllNotifications")}
          label={t(
            "programBuilder.program.details.programNotification.disable.label"
          )}
          readOnly={disabledFields("disableAllNotifications")}
        />
        <ProgramNotificationsList />
      </Stack>
    </Card>
  );
};
